// src/services/dashboard/DeliveryService.js
import axiosInstance from "../../utils/axiosInstance";

const base = "/delivery"; // admin base used by your backend

const DeliveryService = {
  // --- Delivery Partners ------------------------------------------------------
  async getAllBoys(params = {}) {
    const res = await axiosInstance.get(`${base}/boys`, { params });
    return res.data;
  },

  async getBoy(id) {
    const res = await axiosInstance.get(`${base}/boys/${id}`);
    return res.data;
  },

  // Create: supports optional photoFile (multipart) or plain JSON
  async createBoy(boy, photoFile = null) {
    if (photoFile) {
      const fd = new FormData();
      fd.append("boy", JSON.stringify(boy));
      fd.append("photo", photoFile);
      const res = await axiosInstance.post(`${base}/boys`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return res.data;
    } else {
      const res = await axiosInstance.post(`${base}/boys`, boy);
      return res.data;
    }
  },

  async updateBoy(id, boy, photoFile = null) {
    if (photoFile) {
      const fd = new FormData();
      fd.append("boy", JSON.stringify(boy));
      fd.append("photo", photoFile);
      const res = await axiosInstance.put(`${base}/boys/${id}`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return res.data;
    } else {
      const res = await axiosInstance.put(`${base}/boys/${id}`, boy);
      return res.data;
    }
  },

  async deleteBoy(id) {
    const res = await axiosInstance.delete(`${base}/boys/${id}`);
    return res.data;
  },

  // --- Pincodes (areas) --------------------------------------------------
  // Note: backend method names you implemented: getAllPincodes(), getPincodesByCity(cityId)
  async getAllPincodes(params = {}) {
    const res = await axiosInstance.get(`${base}/pincodes`, { params });
    return res.data;
  },

  async getPincodesByCity(cityId) {
    const res = await axiosInstance.get(`${base}/pincodes?cityId=${cityId}`);
    return res.data;
  },

  // create pincode mapping if you expose it: payload { cityId, pinId }
  async createPincode(payload) {
    const res = await axiosInstance.post(`${base}/pincodes`, payload);
    return res.data;
  },

  // --- Assignments --------------------------------------------------------
  // assign pincodes (body: [pinId,...]) -> backend assignPincodesToBoy
  async assignPincodesToBoy(boyId, pinIds = []) {
    const res = await axiosInstance.post(`${base}/boys/${boyId}/pincodes`, pinIds);
    return res.data;
  },

  // Remove assigned pin (if backend has endpoint)
  async removeAssignedPincode(boyId, pinId) {
    const res = await axiosInstance.delete(`${base}/boys/${boyId}/pincodes/${pinId}`);
    return res.data;
  },

  // optional: fetch pincodes assigned to a boy
  async getPincodesForBoy(boyId) {
    const res = await axiosInstance.get(`${base}/boys/${boyId}/pincodes`);
    return res.data;
  },
};

export default DeliveryService;
